import { genderOptions } from "src/constants/common";
import { SupportProgramType } from "src/types/supportProgram.types";

export default {
  psp_name: "Anyra Care",
  logo_url:
    "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anyra-care-program/anyra-logo.png",
  medical_condition_group_id: {
    uat: "0c01eae6-624a-11ec-9077-ab9c0a5eb881",
    prod: "0c01eae6-624a-11ec-9077-ab9c0a5eb881",
  },
  support_program_name: "Anyra Care Program",
  support_program_key: "anyra-care-program",
  program_type: "cycle", // ["cycle", "timeline"]
  loggers: [],
  theme: {
    colors: {
      primary: "#6A1B9A",
      secondary: "#0EB4AC",
      primaryHover: "#501575",
      secondaryHover: "#0B928B",
      primaryBackground: "#F3E8FF",
      secondaryBackground: "#F0F0F0",
      background: "#ffffff",
      foreground: "#ffffff",
      shimmerBackground: "#e2e8f0",
      border: "#e2e8f0",
    },
    fonts: {
      primary: "Roboto",
      secondary: "Open Sans",
      tertiary: "Montserrat",
    },
  },
  config: {
    enableWallet: false,
    enableDrugDelivery: false,
    enableDrugClaimJourney: false,
  },
  documents: {
    document_type: "onco_cycle_report",
    required_documents: [
      {
        id: "prescription",
        title: "Doctor's Prescription",
        description: "Please upload your Anyra prescription",
        required: true,
        supported_file_types: ["pdf", "jpg", "png"],
        max_file_size_in_mb: 10, // 10MB
        document_type: "Prescriptions",
      },
      // {
      //   id: "invoice",
      //   title: "Purchase Invoice",
      //   description:
      //     "Upload your purchase invoice which mentions the medication for which you are availing the program",
      //   required: false,
      //   supported_file_types: ["pdf", "jpg", "png"],
      //   max_file_size_in_mb: 10, // 10MB
      //   document_type: "Invoice",
      // },
    ],
  },
  website: {
    hero_image:
      "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anyra-care-program/anyra-care-program-hero-banner.png",
    benefits: {
      title: "Get Anyra Care Program for free with every purchase",
      subtitle: "Program Offerings",
      benefits: [
        {
          title: "Dedicated Tele Counsellor",
          description:
            "Stay connected with your dedicated guide for constant care and support throughout your treatment journey",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anaya-care/care-specialist.13ba49745298e1ecd2b4.webp",
        },
        {
          title: "Free Consultation with Nutritionist",
          description:
            "After completion of 3 doses, you will be eligible to receive 2 free consultations with a nutritionist.",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anaya-care/coach-consultations-v2.10990432b6554a54a649.png",
        },
        {
          title: "Free Flu Vaccine",
          description:
            "After completion of 3 doses, you will be eligible to receive 1 free flu vaccine.",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anyra-care-program/free-flu-vaccine.jpeg",
        },
        {
          title: "Educational Content",
          description:
            "Explore comprehensive educational resources on the app and understand your condition better.",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anyra-care-program/educational-content.jpeg",
        },
        {
          title: "Health Records Management",
          description:
            "Securely store and access all your medical records easily, retrieve them whenever you need.",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anyra-care-program/health-records.jpeg",
        },
      ],
    },
    faqs: {
      title: "FAQ's",
      faqs: [
        {
          question: "Who should download this app?",
          answer:
            "Between a patient and a caregiver, we highly recommend that the patient downloads this app.",
        },
        {
          question: "Is there an additional fee for this support program?",
          answer:
            "No, this is a free support program as part of your Anyra purchase. There are however certain services within the support program which follow a pay as you go model - for eg., buying care products, booking a test, etc.",
        },
        {
          question: "How secure is my data?",
          answer:
            "All data is secure and stored in encrypted servers. Other than data that is willingly shared for the purposes of availing the service, no other data of the patient is accessed.",
        },
        {
          question: "Who is eligible for this support program?",
          answer:
            "All patients who have been prescribed and have purchased Anyra are eligible for this program.",
        },
      ],
    },
    request_call_section: {
      title: "Request a call",
      description:
        "We're here to help you get started. Request a call and we'll get back to you as soon as possible.",
    },
    disclaimer: {
      title: "Disclaimer",
      description:
        "To report adverse events call on Toll free 1800 419 1141 or send an email to drugsafety@zyduslife.com. This website has been developed solely for educational purposes to provide general information on retinal vascular diseases and about aflibercept, a prescription medicine approved in India for certain retinal conditions. The content on this website does not constitute medical advice, diagnosis, or treatment recommendations, and should not be relied upon as a substitute for consultation with a qualified healthcare professional. Patients should always seek the advice of a registered ophthalmologist or other qualified healthcare provider for diagnosis, treatment, and medical decisions. Any such information is provided only for disease education and awareness.",
    },
  },
  onboarding: {
    steps: [
      {
        id: "mobile_number_capture",
        title: "Enter your mobile number",
        description: "We'll send a verification code to your mobile number",
        type: "mobile_number",
      },
      {
        id: "otp_capture",
        title: "Enter the verification code",
        description: "We'll send a verification code to your mobile number",
        type: "otp",
      },
      {
        id: "user_type_selection",
        title: "Select your user type",
        description: "We'll send a verification code to your mobile number",
        type: "radio",
        options: [
          {
            id: "patient",
            title: "I am a Patient",
            description: "I am a Patient",
          },
          {
            id: "caregiver",
            title: "I am a Caregiver",
            description: "I am a Caregiver",
          },
        ],
      },
      {
        id: "patient_name_capture",
        title: "What is your name?",
        description: "Please enter the full name as per medical records",
        type: "text",
      },
      {
        id: "patient_gender_selection",
        title: "What is your gender?",
        description: "Please select your gender",
        type: "radio",
        options: genderOptions,
      },
      {
        id: "patient_dob_capture",
        title: "What is your date of birth?",
        description: "This helps us provide age-appropriate care",
        type: "date",
      },
      {
        id: "doctor_details_capture",
        title: "Please provide details of the patient's doctor",
        description:
          "We ask your doctor's details to ensure seamless coordination of your care",
        type: "automated_form", // ["automated_form", "manual_form"]
      },
      {
        id: "upload_documents",
        title: "Upload your documents",
        description: "Please upload the following documents",
        type: "document_upload",
        report_type: "acti_liv_program_report",
      },
    ],
  },
  app: {
    screens: {
      "home-screen": {
        id: "home-screen",
        title: "Home",
        description: "This is the home screen",
        type: "home",
        icon: "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/house.svg",
        activeIcon:
          "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/house.svg",
        components: [
          {
            id: "hero-section",
            type: "hero",
            title: "Welcome to Anaya Care",
            description: "Powered by Goodflip, your trusted health partner",
            background_image_url:
              "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/acti-liv-hero-background.png",
            logo_url:
              "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anyra-care-program/anyra-logo.png",
            show_header_items: true,
          },
          {
            id: "journey-card",
            type: "cycle",
            title: "Your Journey",
            description: "See how far you have come",
          },
          {
            id: "quick-actions-card",
            type: "card",
            title: "Quick Actions",
            //description: "Quick actions to take",
            services: [
              {
                id: "take-assessment",
                title: "Check Quality of Life",
                description: "AMD risk assessment",
              },
            ],
          },
          {
            id: "services-card",
            type: "card",
            title: "Your Services",
            description: "Explore services part of your program",
            services: [
              {
                id: "call-telecounselor",
                title: "Call your Telecounsellor",
                description: "Get personalized guidance",
                number: "+917965204172",
              },
              {
                id: "chat",
                title: "Chat with Specialists",
                description: "Get instant support and answers",
              },
              {
                id: "clinical-appointments",
                title: "Clinical Appointments",
                description: "Schedule visits with Doctors",
              },
              {
                id: "book-appointments",
                title: "Connect with a Specialist",
                description: "Wellness experts",
              },
              {
                id: "book-lab-tests", // might be commented for first release
                title: "Lab Tests",
                description: "At discounted prices",
              },
              {
                id: "health-store",
                title: "Health Store",
                description: "Buy care products",
              },
            ],
          },
          //   {
          //     id: "reminders-card",
          //     type: "card",
          //     title: "Reminders",
          //     description: "Actions pending your attention",
          //   },
          //   {
          //     id: "today-progress-card",
          //     type: "card",
          //     title: "Today's Progress",
          //     description: "Track your daily wellness goals",
          //     options: [
          //       {
          //         id: "water-logs",
          //         color: "#3b82f6",
          //         title: "Water",
          //       },
          //       {
          //         id: "steps-logs",
          //         color: "#10b981",
          //         title: "Steps",
          //       },
          //       {
          //         id: "sleep-logs",
          //         color: "#8b5cf6",
          //         title: "Sleep",
          //       },
          //       {
          //         id: "diet-logs",
          //         color: "#3b82f6",
          //         title: "Diet",
          //       },
          //     ],
          //   },
          {
            id: "educational-content-card",
            type: "card",
            title: "Education",
            description: "Learn about retinal health",
          },
          //   {
          //     id: "wallet-card",
          //     type: "card",
          //     title: "Wallet Balance",
          //     description: "Your wallet balance",
          //   },
          {
            id: "powered-by-logo",
          },
        ],
      },
      "records-screen": {
        id: "records-screen",
        title: "Records",
        description: "This is the records screen",
        type: "records",
      },
      // "program-screen": {
      //   id: "program-screen",
      //   title: "Program",
      //   description: "This is the program screen",
      //   type: "program",
      //   program_type: "treatment_journey",
      //   components: [
      //     {
      //       id: "hero-section",
      //       type: "hero",
      //       title: "Your Care Journey",
      //       description: "Comprehensive care with Anaya",
      //       background_image_url:
      //         "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/acti-liv-hero-background.png",
      //       logo_url:
      //         "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/anaya-logo.svg",
      //       show_header_items: false,
      //     },
      //     {
      //       id: "journey-card",
      //       type: "cycle",
      //       title: "Your Journey",
      //       description: "See how far you have come",
      //     },
      //     {
      //       id: "services-card",
      //       type: "card",
      //       title: "Services",
      //       description: "Quick access to care services",
      //       services: [
      //         {
      //           id: "book-appointments",
      //           title: "Book Appointments",
      //           description: "With our Nutritionists",
      //         },
      //         {
      //           id: "health-store",
      //           title: "Health Store",
      //           description: "Buy essentials health products",
      //         },
      //         {
      //           id: "book-lab-tests", // might be commented for first release
      //           title: "Book Lab Tests",
      //           description: "At discounted prices",
      //         },
      //         {
      //           id: "chat",
      //           title: "Chat with Specialists",
      //           description: "Get instant support and answers",
      //         },
      //       ],
      //     },
      //     // {
      //     //   id: "health-store-card",
      //     //   type: "card",
      //     //   title: "Health Store",
      //     //   description: "Everything you need for your health journey",
      //     //   view_all_link: "https://shop.goodflip.in/",
      //     //   options: [
      //     //     {
      //     //       id: "nutraceuticals",
      //     //       title: "Nutraceuticals",
      //     //       description: "This is the nutraceuticals card",
      //     //       link: "https://shop.goodflip.in/collections/supplements",
      //     //     },
      //     //   ],
      //     // },
      //     {
      //       id: "educational-content-card",
      //       type: "card",
      //       title: "Educational Content",
      //       description: "Personalized health tips for your health journey",
      //     },
      //     {
      //       id: "powered-by-logo",
      //     },
      //   ],
      // },
      "health-assistant-screen": {
        id: "health-assistant-screen",
        title: "Health Assistant Screen",
        description: "This is the chat screen",
        type: "health-assistant-screen",
      },
      "insights-screen": {
        id: "insights-screen",
        title: "Insights",
        description: "This is the insights screen",
        type: "insights",
        // tabs are present will code in page(web) - based on condition we will rendet the tabs. Ex: lab test is present then we will show the lab test tab.
        logs: [
          {
            id: "medication-logs",
            icon: "Medication",
            title: "Medication Logs",
            description: "Track your medication schedule and adherence",
          },
          {
            id: "water-logs",
            icon: "Droplets",
            title: "Water Logs",
            description: "Track your daily water intake to stay hydrated",
          },
          {
            id: "sleep-logs",
            icon: "Sleep",
            title: "Sleep Logs",
            description:
              "Track your sleep duration to improve rest and overall well-being",
          },
          {
            id: "steps-logs",
            icon: "Steps",
            title: "Steps Logs",
            description: "Track your step count over time",
          },
          // {
          //   id: "exercise-logs",
          //   icon: "Exercise",
          //   title: "Exercise Logs",
          //   description: "Track your workouts and physical activities",
          // },
          // {
          //   id: "fatigue-logs",
          //   icon: "Fatigue",
          //   title: "Fatigue Logs",
          //   description:
          //     "Track your daily fatigue levels to identify patterns and triggers.",
          // },
          // {
          //   id: "menstruation-logs",
          //   icon: "Menstruation",
          //   title: "Menstruation Logs",
          //   description: "Track your menstrual cycle patterns and symptoms.",
          // },
          {
            id: "diet-logs",
            icon: "Diet",
            title: "Diet Logs",
            description: "Track your nutrition intake and dietary patterns",
          },
        ],
      },
      "chat-screen": {
        id: "chat-screen",
        title: "Chats",
        description: "This is the chat screen",
        type: "chat",
      },
    },
  },
} satisfies SupportProgramType;
